import React from "react";
import './SmartTabs.css'

const SmartTabs = ({ menus, activeMenu, setActiveMenu, placement, alignment, spacing}) => {
    const valid_placements = ["left", "right", "top", "bottom"];
    const valid_alignments = ["left", "center", "right", "equal"];
    placement = !valid_placements.includes(placement) ? valid_placements[0] : placement;
    alignment = !valid_alignments.includes(alignment) ? valid_alignments[0] : alignment;

    const css_classes = "smart-tab aligned-" + alignment + " placed-" + placement;

    const activate = (slug) => {
        return activeMenu === slug ? css_classes + " active" : css_classes;
    };

    return (
        <div>
            <div className={"smart-tabs" + " placed-" + placement + " aligned-" + alignment} style={{rowGap: spacing}}>
                {menus.map((c) => (
                    <button key={c.slug} onClick={() => setActiveMenu(c.slug)}
                        className={activate(c.slug)}>
                        {c.menu_text}
                    </button>
                ))}
            </div>           
        </div>
    );
};

export default SmartTabs;
